<template>
  <div v-if="dataLoaded">
    <v-container>
      <v-row align="center">
        <v-col
          md="4"
          v-if="$model.isMinObr || $model.isDir"
        >
          <v-autocomplete
            variant="underlined"
            :items="$model.modules.job.model.clients"
            v-model="selectedOrg"
            label="Организация"
            item-title="name"
            item-value="id"
            :disabled="$model.isDir"
            @change="filterChange()"
          >
          </v-autocomplete>
        </v-col>

        <v-col md="2">
          <v-select
            :items="years"
            v-model="year"
            label="Год"
            variant="underlined"
            @update:modelValue="filterChange()"
          ></v-select>
        </v-col>

        <v-tooltip
          v-if="!$model.isMinObrHost"
          text="Отправить данные"
          location="top"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              @click="sendOrgData()"
              variant="text"
              v-bind="props"
              color="primary"
              icon="mdi-arrow-up"
            ></v-btn>
          </template>
        </v-tooltip>

        <v-tooltip
          location="top"
          v-if="!$model.isMinObrHost"
          text="Посмотреть лог"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              color="primary"
              variant="text"
              icon="mdi-text-box-multiple"
              v-bind="props"
              @click="openLog()"
            ></v-btn>
          </template>
        </v-tooltip>

        <v-tooltip
          location="top"
          text="Печать сводного отчета"
          v-if="$model.isMinObrHost"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              color="green darken-2"
              variant="text"
              icon="mdi-chart-box"
              v-bind="props"
              @click="excel(true)"
            >
            </v-btn>
          </template>
          <span></span>
        </v-tooltip>

        <v-tooltip
          location="top"
          :text="
            this.ogrn || !$model.isMinObr
              ? 'Печать сводного отчета'
              : 'Печать данных всех организаций'
          "
        >
          <template v-slot:activator="{ props }">
            <v-btn
              color="green darken-2"
              variant="text"
              icon="mdi-microsoft-excel"
              v-bind="props"
              @click="excel()"
            >
            </v-btn>
          </template>
        </v-tooltip>

        <v-divider vertical></v-divider>

        <v-tooltip
          location="top"
          text="Печать сводного отчета(расширенный)"
          v-if="$model.isMinObrHost"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              variant="text"
              color="blue darken-2"
              icon="mdi-chart-box"
              v-bind="props"
              @click="excel(true, true)"
            >
            </v-btn>
          </template>
        </v-tooltip>

        <v-tooltip
          location="top"
          :text="
            this.ogrn || !$model.isMinObr
              ? 'Печать данных организации(расширенный)'
              : 'Печать данных всех организаций(расширенный)'
          "
        >
          <template v-slot:activator="{ props }">
            <v-btn
              variant="text"
              color="blue darken-2"
              icon="mdi-microsoft-excel"
              v-bind="props"
              @click="excel(false, true)"
            >
            </v-btn>
          </template>
        </v-tooltip>

        <span class="pa-2 ml-auto" v-if="!$model.isMinObrHost">
          {{ $model.modules.job.model.JoblastSendings }}
        </span>
      </v-row>
      <v-row align="center">
        <v-col md="6">
          <v-autocomplete
            variant="underlined"
            :items="specialties"
            v-model="search"
            label="Специальность"
            item-value="value"
            item-title="name"
          ></v-autocomplete>
        </v-col>

        <v-col md="6">
          <v-tooltip
            location="top"
            v-if="!$model.isMinObr"
            text="Добавить специальность"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                variant="text"
                color="primary"
                icon="mdi-plus"
                v-bind="props"
                @click="addSpecDialog = true"
              >
              </v-btn>
            </template>
          </v-tooltip>

          <v-tooltip
            location="top"
            v-if="search && !$model.isMinObr"
            text="Удалить специальность"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                variant="text"
                color="primary"
                icon="mdi-delete"
                v-bind="props"
                @click="delSpecDialog = true"
              >
              </v-btn>
            </template>
          </v-tooltip>

          <v-tooltip
            location="top"
            v-if="!$model.isMinObrHost"
            text="Загрузить первичные данные"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                variant="text"
                color="primary"
                icon="mdi-reload"
                v-bind="props"
                @click="reloadReportData()"
              >
              </v-btn>
            </template>
          </v-tooltip>

          <v-tooltip
            location="top"
            v-if="!$model.isMinObrHost"
            text="Загрузить специальности"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                variant="text"
                color="primary"
                icon="mdi-upload"
                v-bind="props"
                @click="loadSpecs()"
              >
              </v-btn>
            </template>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="addSpecDialog" width="600">
      <v-card>
        <v-card-title class="grey lighten-4"
          >Добавить специальность</v-card-title
        >

        <v-card-text>
          <v-container>
            <v-row v-if="!this.$model.isMinObrHost">
              <v-col>
                <v-autocomplete
                  variant="underlined"
                  :items="specialtiesList"
                  v-model="addSpecId"
                  label="Специальность"
                  item-value="id"
                  item-title="name"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addSpecialty()">Добавить</v-btn>
          <v-btn color="primary" @click="addSpecDialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delSpecDialog" width="600">
      <v-card>
        <v-card-title class="grey lighten-4"
          >Удалить специальность</v-card-title
        >

        <v-card-text>
          Вы действительно хотите удалить специальность {{ search }}
        </v-card-text>

        <v-card-actions class="grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="delSpecialty()">Да, удалить</v-btn>
          <v-btn color="primary" @click="delSpecDialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="logDialog">
      <v-card>
        <v-card-title class="grey lighten-4"
          >Лог отправленных запросов</v-card-title
        >

        <v-card-text>
          <v-container>
            <v-row>
              <v-col md="6">
                <v-select
                  variant="underlined"
                  :items="logList"
                  v-model="selectedLog"
                  @update:modelValue="logChange()"
                  item-value="id"
                  item-title="time"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6">
                <v-text-field
                  variant="underlined"
                  v-model="logSearch"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <v-data-table
            :items="logData"
            :headers="headers"
            :search="logSearch"
            items-per-page="-1"
            class="adminTable"
          >
            <template v-slot:header="{ props }">
              <thead>
                <tr>
                  <th
                    v-for="(head, idx) in props.headers"
                    :class="head.class"
                    :key="idx"
                  >
                    <v-tooltip location="top" :text="head.title" max-width="800">
                      <template v-slot:activator="{ attrs }">
                        <div v-bind="attrs" class="hide-long-text">
                          {{ head.text }}
                        </div>
                      </template>
                    </v-tooltip>
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:bottom> </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="logDialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table
      :items="data"
      :headers="headers"
      :search="search"
      class="adminTable"
      items-per-page="-1"
      style="max-height: 100vh"
    >
      <template v-slot:headers="{ columns }">
        <tr>
          <th v-for="(head, idx) in columns" :class="head.class" :key="idx">
            <v-tooltip location="top" :text="head.title" max-width="800">
              <template v-slot:activator="{ props }">
                <div v-bind="props" class="hide-long-text">
                  {{ head.title }}
                </div>
              </template>
            </v-tooltip>
          </th>
        </tr>
      </template>

      <template v-slot:item="{ item }">
        <tr>
          <template v-for="(header, idx) in headers">
            <td
              :key="idx"
              v-if="
                header.key != 'name' &&
                header.key != 'graduated' &&
                header.key != 'str_num' &&
                header.key == editedCell.column &&
                item.id === editedCell.item.id &&
                !$model.isMinObr &&
                item.str_num != '06' &&
                item.str_num == editedCell.item.str_num
              "
              :class="header.class"
            >
              <v-text-field
                v-model="item[header.key]"
                :hide-details="true"
                dense
                single-line
                :autofocus="true"
                v-on:keyup.enter="saveItemAndClose()"
              >
              </v-text-field>
            </td>

            <td
              v-else
              :key="idx + '_'"
              @click.stop="
                header.key != 'name' &&
                header.key != 'graduated' &&
                header.key != 'spec_code' &&
                header.key != 'spec_name' &&
                header.key != 'str_num' &&
                item.str_num != '06'
                  ? editItem(item, header.key)
                  : null
              "
              :class="[
                header.key != 'name' &&
                header.key != 'graduated' &&
                header.key != 'spec_code' &&
                header.key != 'spec_name' &&
                header.key != 'str_num'
                  ? 'pointer'
                  : '',
                header.class,
              ]"
            >
              <span>{{ item[header.key] }}</span>
              <p v-if="idx == 0">{{ item["lastmodified"] }}</p>
            </td>
          </template>
        </tr>
      </template>

      <template v-slot:bottom> </template>
    </v-data-table>
  </div>
  <div v-else>
    <spinner />
  </div>
</template>

<script>
import spinner from "../../../../blocks/manage_groups/documents2/components/spinner.vue";
export default {
  components: { spinner },
  name: "admin",
  data() {
    return {
      dataLoaded: true,
      logSearch: "",
      logDialog: false,
      selectedLog: null,
      logData: [],
      logList: [],
      addSpecDialog: false,
      delSpecDialog: false,
      search: "",
      years: [],
      year: null,
      report: [],
      data: [],
      ogrn: "",
      specialtiesList: [],
      specialties: [
        {
          name: "Все",
          value: "",
        },
      ],
      addSpecId: "",
      selectedOrg: null,
      editedCell: {
        item: null,
        column: "",
      },
      headers: [
        {
          title: "Код спец-ти",
          sortable: true,
          key: "spec_code",
        },
        {
          title: "Наименование спец-ти",
          sortable: true,
          key: "spec_name",
        },
        {
          title: "Номер строки",
          sortable: false,
          key: "str_num",
        },
        {
          title: "Наименование показателей",
          sortable: false,
          key: "name",
        },
        {
          title: "Суммарный выпуск",
          sortable: true,
          key: "graduated",
          filterable: false,
        },
        {
          title:
            "Трудоустроены (по трудовому договору, договору ГПХ в соответствии с трудовым законодательством, \
                    законодательством  об обязательном пенсионном страховании)",
          sortable: true,
          key: "has_job",
          filterable: false,
          class: "platinum",
        },
        {
          title:
            "В том числе (из трудоустроенных): в соответствии с освоенной профессией, специальностью \
                    (исходя из осуществляемой трудовой функции)",
          sortable: true,
          key: "has_job_by_spec",
          filterable: false,
          class: "platinum",
        },
        {
          title:
            "В том числе (из трудоустроенных): работают на протяжении не менее 4-х месяцев на последнем месте работы",
          sortable: true,
          key: "has_job_4month",
          filterable: false,
          class: "platinum",
        },
        {
          title: "Индивидуальные предприниматели",
          sortable: true,
          key: "business",
          filterable: false,
          class: "platinum",
        },
        {
          title:
            "Самозанятые (перешедшие на специальный налоговый режим  - налог на профессио-нальный доход)",
          sortable: true,
          key: "freelance",
          filterable: false,
          class: "platinum",
        },
        {
          title: "Продолжили обучение",
          sortable: true,
          key: "student",
          filterable: false,
          class: "platinum",
        },
        {
          title: "Проходят службу в армии по призыву",
          sortable: true,
          key: "army",
          filterable: false,
          class: "lightblue",
        },
        {
          title:
            "Проходят службу в армии на контрактной основе, в органах внутренних дел, Государственной противопожарной службе, \
                    органах по контролю за оборотом наркотических средств и психотропных веществ, учреждениях и органах уголовно-исполнительной системы, \
                    войсках национальной гвардии Российской Федерации, органах принудительного исполнения Российской Федерации",
          sortable: true,
          key: "army_contract",
          filterable: false,
          class: "lightblue",
        },
        {
          title: "Находятся в отпуске по уходу за ребенком",
          sortable: true,
          key: "parental_leave",
          filterable: false,
          class: "lightblue",
        },
        {
          title: "Неформальная занятость (нелегальная)",
          sortable: true,
          key: "unformal_job",
          filterable: false,
          class: "lightyellow",
        },
        {
          title:
            "Зарегистрированы в центрах занятости в качестве безработных (получают пособие по безработице) и не планируют трудоустраиваться",
          sortable: true,
          key: "looking_job",
          filterable: false,
          class: "lightyellow",
        },
        {
          title:
            "Не имеют мотивации к трудоустройству (кроме зарегистрированных в качестве безработных) и не планируют трудоустраиваться, \
                    в том числе по причинам получения иных социальных льгот",
          sortable: true,
          key: "marginal",
          filterable: false,
          class: "lightyellow",
        },
        {
          title: "Иные причины нахождения под риском нетрудоустройства",
          sortable: true,
          key: "other_unemployed",
          filterable: false,
          class: "lightyellow",
        },
        {
          title: "Смерть, тяжелое состояние здоровья",
          sortable: true,
          key: "health_problems",
          filterable: false,
          class: "lightgreen",
        },
        {
          title: "Находятся под следствием, отбывают наказание",
          sortable: true,
          key: "prisoner",
          filterable: false,
          class: "lightgreen",
        },
        {
          title:
            "Переезд за пределы Российской Федерации(кроме переезда в иные регионы - по ним регион должен располагать сведениями)",
          sortable: true,
          key: "migrant",
          filterable: false,
          class: "lightgreen",
        },
        {
          title:
            "Не могут трудоустраиваться в связи с уходом за больными родственниками, в связи с иными семейными обстоятельствами",
          sortable: true,
          key: "family_problems",
          filterable: false,
          class: "lightgreen",
        },
        {
          title:
            "Выпускники из числа иностранных граждан, которые не имеют СНИЛС",
          sortable: true,
          key: "no_snils",
          filterable: false,
          class: "lightgreen",
        },
        {
          title:
            "Иное(в первую очередь выпускники распределяются по всем остальным графам)",
          sortable: true,
          key: "other_unemployed1",
          filterable: false,
          class: "lightgreen",
        },
        {
          title: "будут трудоустроены",
          sortable: true,
          key: "will_job",
          filterable: false,
          class: "margenta",
        },
        {
          title: "будут осуществлять предпринимательскую деятельность",
          sortable: true,
          key: "will_business",
          filterable: false,
          class: "margenta",
        },
        {
          title: "будут самозанятыми",
          sortable: true,
          key: "will_freelance",
          filterable: false,
          class: "margenta",
        },
        {
          title: "будут призваны в армию",
          sortable: true,
          key: "will_army",
          filterable: false,
          class: "margenta",
        },
        {
          title:
            "будут в армии на контрактной основе, в органах внутренних дел, Государственной противопожарной службе, \
                    органах по контролю за оборотом наркотических средств и психотропных веществ, учреждениях и органах уголовно-исполнительной системы, \
                    войсках национальной гвардии Российской Федерации, органах принудительного исполнения Российской Федерации",
          sortable: true,
          key: "will_army_contract",
          filterable: false,
          class: "margenta",
        },
        {
          title: "будут продолжать обучение",
          sortable: true,
          key: "will_student",
          filterable: false,
          class: "margenta",
        },
        {
          title:
            "Принимаемые меры по содействию занятости (тезисно - вид меры, охват выпускников мерой)",
          sortable: true,
          key: "actions",
          filterable: false,
        },
      ],
    };
  },
  created() {
    this.getspecialties();
    if (
      this.$model.isMinObrHost &&
      this.$model.modules.job.model.clients
    ) {
      this.selectedOrg = this.$model.modules.job.model.clients[0].id;
    }
    
    
    this.years=this.$model.modules.job.model.years;
    
    this.year = this.years[0];
    this.filterChange();
  },
  mounted: function () {
    document.addEventListener("click", this.saveItemAndClose);
  },
  beforeDestroy: function () {
    document.removeEventListener("click", this.saveItemAndClose);
  },
  methods: {
    loadSpecs() {
      this.dataLoaded = false;
      this.axios
        .post(
          this.$model.wwwroot + "/procolleg/report/minobr/job/loadSpecs",
          new URLSearchParams({
            year: this.year,
          }),
          {
            headers: {
              Accept: "application/json",
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        )
        .then((resp) => {
          this.dataLoaded = true;
          this.dataReceive(resp.data);
        })
        .catch((reject) => {
          this.dataLoaded = true;
          this.reject(reject);
          if (
            reject.response != undefined &&
            reject.response.data != undefined
          ) {
            this.$eventBus.$emit(
              "show-dialog",
              "Ошибка",
              JSON.parse(reject.response.data).message
            );
          }
        });
    },
    logChange() {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/job/getLog",
          new URLSearchParams({
            id: this.selectedLog,
          }),
          {
            headers: {
              Accept: "application/json",
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        )
        .then((resp) => {
          this.dataReceive(resp.data, 0);
        })
        .catch((reject) => {
          this.reject(reject);
          if (
            reject.response != undefined &&
            reject.response.data != undefined
          ) {
            this.$eventBus.$emit(
              "show-dialog",
              "Ошибка",
              JSON.parse(reject.response.data).message
            );
          }
        });
    },
    openLog() {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/job/getLogList",
          new URLSearchParams({
            year: this.year,
          }),
          {
            headers: {
              Accept: "application/json",
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        )
        .then((resp) => {
          this.logList = resp.data;
          this.logDialog = true;
        })
        .catch((reject) => {
          this.reject(reject);
          if (
            reject.response != undefined &&
            reject.response.data != undefined
          ) {
            this.$eventBus.$emit(
              "show-dialog",
              "Ошибка",
              JSON.parse(reject.response.data).message
            );
          }
        });
    },
    sendOrgData() {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/job/sendOrgData",
          new URLSearchParams({
            year: this.year,
          }),
          {
            headers: {
              Accept: "application/json",
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        )
        .then((resp) => {
          this.$eventBus.$emit(
            "show-dialog",
            "Ответ",
            JSON.parse(resp.data.message).message
          );
        })
        .catch((reject) => {
          this.reject(reject);
          if (
            reject.response != undefined &&
            reject.response.data != undefined
          ) {
            this.$eventBus.$emit(
              "show-dialog",
              "Ошибка",
              JSON.parse(reject.response.data).message
            );
          }
        });
    },
    reloadReportData() {
      if (
        !confirm(
          "Если выбрана специальность, то будут обновлены данные только по этой специальности. Иначе - по всем специальностям"
        )
      ) {
        return;
      }
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/job/reloadReportData",
          new URLSearchParams({
            year: this.year,
            code: this.search,
          }),
          {
            headers: {
              Accept: "application/json",
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        )
        .then((resp) => {
          this.dataReceive(resp.data);
        })
        .catch((reject) => {
          this.reject(reject);
        });
    },
    excel(isConsolidated, isExtended) {
      isConsolidated = isConsolidated == undefined || !isConsolidated ? 0 : 1;
      isExtended = isExtended == undefined || !isExtended ? 0 : 1;
      document.location.href =
        this.$model.wwwroot +
        "/procollege/report/minobr/job/excel?year=" +
        this.year +
        "&ogrn=" +
        this.ogrn +
        "&isConsolidated=" +
        isConsolidated +
        "&isExtended=" +
        isExtended;
    },
    getspecialties() {
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/job/getSpecialties",
          null,
          {
            headers: {
              Accept: "application/json",
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        )
        .then((resp) => {
          this.specialtiesList = resp.data;
        })
        .catch((reject) => {
          this.reject(reject);
        });
    },
    addSpecialty() {
      this.addSpecDialog = false;
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/job/addSpecialty",
          new URLSearchParams({
            year: this.year,
            id: this.addSpecId,
          }),
          {
            headers: {
              Accept: "application/json",
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        )
        .then((resp) => {
          this.addSpecId = "";
          this.dataReceive(resp.data);
        })
        .catch((reject) => {
          this.reject(reject);
        });
    },

    delSpecialty() {
      this.delSpecDialog = false;
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/job/delSpecialty",
          new URLSearchParams({
            year: this.year,
            code: this.search,
          }),
          {
            headers: {
              Accept: "application/json",
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        )
        .then((resp) => {
          this.addSpecId = "";
          this.dataReceive(resp.data);
        })
        .catch((reject) => {
          this.reject(reject);
        });
    },
    saveItemAndClose() {
      if (this.editedCell.item != null) {
        this.saveItem();
        this.editedCell.item = null;
        this.editedCell.column = "";
      }
    },
    recalcSixRow() {},
    saveItem() {
      let editedCell = Object.assign({}, this.editedCell);
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/job/setReport",
          new URLSearchParams({
            data: JSON.stringify(this.editedCell.item),
            ogrn: this.ogrn,
            year: this.year,
          }),
          {
            headers: {
              Accept: "application/json",
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        )
        .then((resp) => {
          //только обновление измененной строки(суммарный выпуск)
          for (let ogrn in resp.data) {
            for (let code in resp.data[ogrn]) {
              for (let row in resp.data[ogrn][code]) {
                if (
                  resp.data[ogrn][code][row]["id"] == editedCell.item.id
                ) {
                  for(let i in this.data){
                    if(this.data[i].id==editedCell.item.id){
                      this.data[i].graduated=resp.data[ogrn][code][row].graduated;
                      return;
                    }
                  }

                }
              }
            }
          }

          //this.dataReceive(resp.data);//быстро последовательно вводим данные, из-за задержки с ответом
          //обратно возвращаются уже неактуальные данные
        })
        .catch((reject) => {
          this.reject(reject);
        });
    },
    editItem(item, colName) {
      if (item !== this.editedCell.item) {
        this.saveItemAndClose();
      }
      this.editedCell.item = item;
      this.editedCell.column = colName;
    },
    filterChange() {
      if (this.selectedOrg) {
        this.$model.modules.job.model.clients.forEach((element) => {
          if (element.id == this.selectedOrg) {
            this.ogrn = element.ogrn;
          }
        });
      } else {
        this.ogrn = null;
      }
      this.getReport();
    },
    getReport() {
      this.dataLoaded = false;
      this.groups = [];
      this.students = {};
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/job/getReport",
          new URLSearchParams({
            year: this.year,
            ogrn: this.ogrn,
          }),
          {
            headers: {
              Accept: "application/json",
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        )
        .then((resp) => {
          this.dataLoaded = true;
          this.dataReceive(resp.data);
        })
        .catch((reject) => {
          this.dataLoaded = true;
          this.reject(reject);
        });
    },
    dataReceive(resp, isMainTable) {
      isMainTable = isMainTable == undefined || isMainTable ? 1 : 0;
      if (isMainTable) {
        this.data = [];
        let tmp = {};
        for (let ogrn in resp) {
          for (let code in resp[ogrn]) {
            if (tmp[code] == undefined) {
              tmp[code] = resp[ogrn][code];
              continue;
            }

            let rows = [
              "all",
              "invalid",
              "ovz",
              "ovz_invalid",
              "target",
              "all_ovz_invalid",
            ];
            rows.forEach((row) => {
              for (let field in resp[ogrn][code][row]) {
                if (!Number.isInteger(tmp[code][row][field])) {
                  continue;
                }

                tmp[code][row][field] += resp[ogrn][code][row][field];
              }
            });
          }
        }
        resp = tmp;
      } else {
        this.logData = [];
      }
      if (Object.keys(resp).length == 0) {
        return;
      }
      this.specialties = [
        {
          name: "Все",
          value: "",
        },
      ];

      for (let code in resp) {
        this.specialties.push({
          name: code + " " + resp[code]["all"]["spec_name"],
          value: code,
        });
        resp[code]["all"]["name"] = "Всего (общая численность выпускников)";
        resp[code]["all"]["str_num"] = "01";
        if (isMainTable) {
          this.data.push(resp[code]["all"]);
        } else {
          this.logData.push(resp[code]["all"]);
        }

        resp[code]["ovz"]["name"] =
          "из общей численности выпускников (из строки 01): лица с ОВЗ";
        resp[code]["ovz"]["str_num"] = "02";
        if (isMainTable) {
          this.data.push(resp[code]["ovz"]);
        } else {
          this.logData.push(resp[code]["ovz"]);
        }

        resp[code]["ovz_invalid"]["name"] =
          "из числа лиц с ОВЗ (из строки 02): инвалиды и дети-инвалиды";
        resp[code]["ovz_invalid"]["str_num"] = "03";
        if (isMainTable) {
          this.data.push(resp[code]["ovz_invalid"]);
        } else {
          this.logData.push(resp[code]["ovz_invalid"]);
        }

        resp[code]["invalid"]["name"] =
          "Инвалиды и дети-инвалиды (кроме учтенных в строке 03)";
        resp[code]["invalid"]["str_num"] = "04";
        if (isMainTable) {
          this.data.push(resp[code]["invalid"]);
        } else {
          this.logData.push(resp[code]["invalid"]);
        }

        resp[code]["target"]["name"] = "Имеют договор о целевом обучении";
        resp[code]["target"]["str_num"] = "05";
        if (isMainTable) {
          this.data.push(resp[code]["target"]);
        } else {
          this.logData.push(resp[code]["target"]);
        }

        resp[code]["all_ovz_invalid"]["name"] =
          "Автосумма строк 02 и 04 - Всего (общая численность выпускников из числа лиц с ОВЗ, инвалидов и детей-инвалидов)";
        resp[code]["all_ovz_invalid"]["str_num"] = "06";
        if (isMainTable) {
          this.data.push(resp[code]["all_ovz_invalid"]);
        } else {
          this.logData.push(resp[code]["all_ovz_invalid"]);
        }

        resp[code]["eye_trouble"]["name"] =
          "из общей численности выпускников из числа лиц с ОВЗ, инвалидов и детей-инвалидов (из строки 06): с нарушениями: зрения";
        resp[code]["eye_trouble"]["str_num"] = "07";
        if (isMainTable) {
          this.data.push(resp[code]["eye_trouble"]);
        } else {
          this.logData.push(resp[code]["eye_trouble"]);
        }

        resp[code]["hearing_trouble"]["name"] = "слуха";
        resp[code]["hearing_trouble"]["str_num"] = "08";
        if (isMainTable) {
          this.data.push(resp[code]["hearing_trouble"]);
        } else {
          this.logData.push(resp[code]["hearing_trouble"]);
        }

        resp[code]["moving_trouble"]["name"] = "опорно-двигательного аппарата";
        resp[code]["moving_trouble"]["str_num"] = "09";
        if (isMainTable) {
          this.data.push(resp[code]["moving_trouble"]);
        } else {
          this.logData.push(resp[code]["moving_trouble"]);
        }

        resp[code]["speaking_trouble"]["name"] = "тяжелыми нарушениями речи";
        resp[code]["speaking_trouble"]["str_num"] = "10";
        if (isMainTable) {
          this.data.push(resp[code]["speaking_trouble"]);
        } else {
          this.logData.push(resp[code]["speaking_trouble"]);
        }

        resp[code]["mental_trouble"]["name"] =
          "задержкой психического развития";
        resp[code]["mental_trouble"]["str_num"] = "11";
        if (isMainTable) {
          this.data.push(resp[code]["mental_trouble"]);
        } else {
          this.logData.push(resp[code]["mental_trouble"]);
        }

        resp[code]["autism"]["name"] = "расстройствами аутистического спектра";
        resp[code]["autism"]["str_num"] = "12";
        if (isMainTable) {
          this.data.push(resp[code]["autism"]);
        } else {
          this.logData.push(resp[code]["autism"]);
        }

        resp[code]["other_invalid"]["name"] =
          "с инвалидностью вследствие других причин";
        resp[code]["other_invalid"]["str_num"] = "13";
        if (isMainTable) {
          this.data.push(resp[code]["other_invalid"]);
        } else {
          this.logData.push(resp[code]["other_invalid"]);
        }

        resp[code]["ovz_target"]["name"] =
          "из общей численности выпускников из числа лиц с ОВЗ, инвалидов и детей-инвалидов (из строки 06):\
        имеют договор о целевом обучении";
        resp[code]["ovz_target"]["str_num"] = "14";
        if (isMainTable) {
          this.data.push(resp[code]["ovz_target"]);
        } else {
          this.logData.push(resp[code]["ovz_target"]);
        }

        resp[code]["abilimpiks"]["name"] =
          "из общей численности выпускников из числа лиц с ОВЗ, инвалидов и детей-инвалидов (из строки 06):\
        принимали участие в чемпионате «Абилимпикс»";
        resp[code]["abilimpiks"]["str_num"] = "15";
        if (isMainTable) {
          this.data.push(resp[code]["abilimpiks"]);
        } else {
          this.logData.push(resp[code]["abilimpiks"]);
        }
      }
    },
    reject(reject) {
      if (reject.response != undefined && reject.response.data != undefined) {
        this.$eventBus.$emit("show-dialog", "Ошибка", reject.response.data);
      }
    },
  },
};
</script>
<style scoped>
table > tbody > tr > td:nth-child(1),
table > thead > tr > th:nth-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 1;
  background-color: white;
  opacity: 1;
  min-width: 100px;
}

.adminTable table > tbody > tr > td:nth-child(2),
.adminTable table > thead > tr > th:nth-child(2) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 90px;
  z-index: 2;
  background-color: white;
  opacity: 1;
  min-width: 100px;
}

.adminTable table > tbody > tr > td:nth-child(3),
.adminTable table > thead > tr > th:nth-child(3) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 190px;
  z-index: 3;
  background-color: white;
  opacity: 1;
  min-width: 100px;
}

.adminTable table > tbody > tr > td:nth-child(4),
.adminTable table > thead > tr > th:nth-child(4) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 250px;
  z-index: 4;
  background-color: white;
  opacity: 1;
  min-width: 100px;
}

.pointer {
  cursor: pointer;
}

.hide-long-text {
  max-height: 150px;
  overflow: hidden;
}

.platinum {
  background-color: #f0f0f0 !important;
}

.lightblue {
  background-color: #f0ffff !important;
}

.lightyellow {
  background-color: #fffff0 !important;
}

.lightgreen {
  background-color: #f0fff0 !important;
}

.margenta {
  background-color: #fff0ff !important;
}

.v-data-table__wrapper td p {
  margin-bottom: 0;
}
</style>
